export default __webpack_public_path__ + "static/scoring_logo-5c1bea14c97131142f9a933bfa4bb48f.png";